import { render, staticRenderFns } from "./PortalFacturacion.vue?vue&type=template&id=077ec61c&"
import script from "./PortalFacturacion.vue?vue&type=script&lang=js&"
export * from "./PortalFacturacion.vue?vue&type=script&lang=js&"
import style0 from "./PortalFacturacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports